// Glyph key for a forecast condition (shared/WeatherGlyph draws it).
// Conditions arrive in more than one shape ('Clear', 'clear', 'light rain'),
// so match on the word rather than the exact key. One mapping for the
// Timeline's info bar, the weather sheet and the itinerary's day headers, so
// one day shows one sky in all three.
export function weatherIconName(condition) {
  const c = String(condition || '').toLowerCase();
  if (c.includes('thunder')) return 'bolt';
  if (c.includes('snow')) return 'snowflake';
  if (c.includes('drizzle')) return 'rain';
  if (c.includes('rain') || c.includes('shower')) return 'cloudRain';
  if (c.includes('fog') || c.includes('mist') || c.includes('haze')) return 'fog';
  if (c.includes('partly') || c.includes('few') || c.includes('scattered')) return 'sunCloud';
  if (c.includes('cloud') || c.includes('overcast')) return 'cloud';
  if (c.includes('clear') || c.includes('sun')) return 'sun';
  return 'sunCloud';
}
